// extracted by mini-css-extract-plugin
export var container = "_6y-0";
export var containerTopRight = "_6y-1";